import { createActions } from 'redux-actions'

import { getShareText } from '../../utils/share'

export const {
  share: {
    share,
    close: shareClose,
    success: shareSuccess,
    failure: shareFailure
  }
} = createActions({
  SHARE: {
    SHARE: ({ title, text, url }) => ({ title, url, text: text || getShareText() }),
    CLOSE: () => ({}),
    SUCCESS: () => ({}),
    FAILURE: () => ({})
  }
})
